export const antiHijackingSequence = 'while(1); ';
export const antiHijackingSequenceLength = antiHijackingSequence.length;

export default text =>
  (text.indexOf(antiHijackingSequence) === 0 && text.substring(antiHijackingSequenceLength))
  || text;
